import "core-js/modules/web.dom-collections.iterator.js";
import React, { useCallback, useEffect, useState } from 'react';
import { IconButton, LinkButton } from '@eika/button';
import { IconTypes } from '@eika/icon';
import { AnswerType, ListFieldType } from '../generated-types';
import { getNameForSubListQuestion } from '../util/field-name';
import HelpModal from '../util/helpModals/help-modal';
import { composeValidators, valueNotAllowed, requiredField, positiveNumbersOnly } from '../util/validator';
import SelectInput from './select-input';
import { StandardInputField } from './standard-input-field';
export const DELETED_ROW_ID = 'DELETED';
const ListQuestionType = _ref => {
  let {
    question,
    name,
    countries,
    setValueOfField,
    setInitialValueOfSpecialFields
  } = _ref;
  const [rows, setRows] = useState([]);
  const [lastUsedIndex, setLastUsedIndex] = useState(0);
  useEffect(() => {
    if (setValueOfField && setInitialValueOfSpecialFields) {
      setValueOfField({
        key: name,
        value: {
          questionId: question.id,
          questionVersion: question.version,
          answerType: AnswerType.LIST
        }
      });
    }
  }, [name, question, setValueOfField, setInitialValueOfSpecialFields]);

  // TODO: Fix to get proper values if it's going to be something other than countries
  const getDropDownValues = () => {
    if (countries !== null && countries !== void 0 && countries.countries) {
      const countryList = countries.countries.filter(country => !country.historicUseOnly).map(country => {
        return {
          text: country.text,
          value: country.iso2
        };
      });
      return [{
        text: 'Velg',
        value: 'velg'
      }, ...countryList];
    }
    return [];
  };
  const getFieldWithCorrectType = (questionCode, field, index) => {
    switch (field.type) {
      case ListFieldType.AMOUNT:
      case ListFieldType.INTEGER:
        return /*#__PURE__*/React.createElement(StandardInputField, {
          type: "number",
          label: field.text,
          name: getNameForSubListQuestion(name, index, field.code),
          validate: composeValidators(requiredField, positiveNumbersOnly),
          infoButton: /*#__PURE__*/React.createElement(HelpModal, {
            questionId: field.code,
            helpText: field.helpText
          })
        });
      case ListFieldType.DROP_DOWN:
        return /*#__PURE__*/React.createElement(SelectInput, {
          name: getNameForSubListQuestion(name, index, field.code),
          values: getDropDownValues(),
          label: /*#__PURE__*/React.createElement("div", null, field.text, /*#__PURE__*/React.createElement(HelpModal, {
            questionId: field.code,
            helpText: field.helpText
          })),
          validate: composeValidators(requiredField, value => valueNotAllowed(value, 'velg', 'Velg'))
        });
      case ListFieldType.STRING:
        return /*#__PURE__*/React.createElement(StandardInputField, {
          label: field.text,
          name: getNameForSubListQuestion(name, index, field.code),
          validate: requiredField,
          infoButton: /*#__PURE__*/React.createElement(HelpModal, {
            questionId: field.code,
            helpText: field.helpText
          })
        });
      default:
        return "".concat(field.text, " - ").concat(field.type, "(UNSUPPORTED)");
    }
  };
  const addRow = useCallback(() => {
    const id = "".concat(Math.random()).slice(2).padEnd(20, '0');
    const newIndex = lastUsedIndex + 1;
    setLastUsedIndex(newIndex);
    const newRow = {
      id,
      index: newIndex
    };
    setRows([...rows, newRow]);
  }, [rows, lastUsedIndex]);
  useEffect(() => {
    if (rows.length === 0) {
      addRow();
    }
  }, [addRow, rows.length]);
  const onRemove = id => {
    const indexToRemove = rows.findIndex(row => id === row);
    if (indexToRemove >= 0) {
      const newRows = [...rows];
      newRows[indexToRemove].id = DELETED_ROW_ID;
      setRows(newRows);
      if (setValueOfField) {
        setValueOfField({
          key: "".concat(name, ".listAnswers[").concat(indexToRemove, "]"),
          value: undefined
        });
      }
    }
  };
  const getRows = () => {
    return rows.map((row, i) => {
      if (row.id !== DELETED_ROW_ID) {
        var _question$fields;
        return /*#__PURE__*/React.createElement("div", {
          key: row.index,
          className: "sub-question-wrapper fields-row"
        }, /*#__PURE__*/React.createElement(IconButton, {
          className: "sgw-button remove-icon",
          onClick: () => onRemove(row),
          icon: IconTypes.KRYSS_24,
          screenReaderText: "fjern rad fra skjema"
        }), (_question$fields = question.fields) === null || _question$fields === void 0 ? void 0 : _question$fields.map(field => {
          return /*#__PURE__*/React.createElement("div", {
            key: field.code,
            className: "input-field"
          }, getFieldWithCorrectType(question.code, field, i));
        }));
      }
      return undefined;
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, question.text && /*#__PURE__*/React.createElement("div", {
    className: "list-question-header"
  }, question.text, ' ', /*#__PURE__*/React.createElement("span", {
    className: "sgw-input__info-button-wrapper"
  }, /*#__PURE__*/React.createElement(HelpModal, {
    questionId: question.id,
    helpText: question.helpText
  }))), /*#__PURE__*/React.createElement("div", {
    className: "list-item-rows"
  }, getRows(), /*#__PURE__*/React.createElement(LinkButton, {
    id: "addMore",
    icon: IconTypes.PLUSS_24,
    onClick: addRow
  }, "Legg til")));
};
export default ListQuestionType;